import React from 'react';
// import MaskedInput from 'react-maskedinput';
import MaskedInput from "react-text-mask";

export default function PassportSeriesInput(props) {
  return (
    <MaskedInput
    mask={ [/^[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ]/, /[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ]/] }
      placeholder=""
      {...props}
      // formatCharacters={{
      //   W: {
      //     validate: char => /[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ]/.test(char),
      //     transform: char => char.toUpperCase()
      //   }
      // }}
    />
  );
}
